import useTimerCounter from "../hooks/use-timer";

export default function CountdownCm({t}) {
    const { m, s, h } = useTimerCounter(t);
  return (
    <span className="countdown font-mono text-2xl" dir="ltr">
  <span style={{"--value":h}}></span>:
  <span style={{"--value":m}}></span>:
  <span style={{"--value":s}}></span>
</span>
  )
}
